/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Demo_ChaptersInputs */

const en_funnel_demo_chapters = /** @type {(inputs: Funnel_Demo_ChaptersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chapters`)
};

const es_funnel_demo_chapters = /** @type {(inputs: Funnel_Demo_ChaptersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capítulos`)
};

/**
* | output |
* | --- |
* | "Chapters" |
*
* @param {Funnel_Demo_ChaptersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_demo_chapters = /** @type {((inputs?: Funnel_Demo_ChaptersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Demo_ChaptersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_demo_chapters(inputs)
	return en_funnel_demo_chapters(inputs)
});